/** @format */

import React, { useEffect, useState } from 'react';
import { PrefixUploadCollectionInterface, PrefixUploadInterface } from '../../../modules/prefixes/interfaces/PrefixUploadInterface';
import GeneralDialog from '../../../components/Dialog/GeneralDialog';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { prefixesConstants } from '../../../modules/prefixes/actions';
import { REQUEST_STATE } from '../../../helpers/RequestHelper';
import { useDispatch } from 'react-redux';
import { configDefault } from '../../../core/config';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import { StorageProductToCsv } from '../../../modules/storage/StorageProductToCsv';
import { Auth, tokenInfo } from '../../../modules/auth/Auth';
import { PricelistSchemaToCsv } from '../../Pricelists/Components/Csv/PricelistSchemaToCsv';
import { PrefixToCsv } from './PrefixUploadReportToCsv';
import Pager from '../../../components/Adescom/Pager';

interface PrefixUploadReportViewInterface {
    prefixUploadFile: PrefixUploadInterface | null;
    closeReportView: () => void;
}

const REPORT_PREFIX_MODIFIED = 'report_prefix_modified';
const REPORT_PREFIX_ADDED = 'report_prefix_added';
const REPORT_PREFIX_SKIPPED = 'report_prefix_skipped';
const REPORT_PREFIX_REMOVED = 'report_prefix_removed';

const PrefixUploadReportView: React.FC<PrefixUploadReportViewInterface> = (props) => {
    const { prefixUploadFile, closeReportView } = props;
    const dispatch = useDispatch();
    const reportContent = prefixUploadFile?.reportMessage ? JSON.parse(prefixUploadFile.reportMessage) : null;
    const [reportContentList, setReportContentList] = useState<any>(null);

    const paginationCallbackFunction = (uri: string): void => {
        if (prefixUploadFile) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                prefixesConstants.PREFIX_UPLOAD_LIST,
                [{ name: 'prefixUploadId', value: prefixUploadFile.id }],
                [{ name: 'lineNumber', value: 'asc' }],
                {
                    onSuccess: (data: PrefixUploadCollectionInterface) => {
                        setReportContentList(data);
                    },
                    onError: (error: any) => {
                        setReportContentList(null);
                    },
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    };

    const closeReportViewCallback = (): void => {
        closeReportView();
        setReportContentList(null);
    };

    useEffect(() => {
        if (prefixUploadFile) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/prefix_upload_reports', configDefault.PLATFORM_API_PREFIX)),
                prefixesConstants.PREFIX_UPLOAD_LIST,
                [{ name: 'prefixUploadId', value: prefixUploadFile.id }],
                [{ name: 'lineNumber', value: 'asc' }],
                {
                    onSuccess: (data: PrefixUploadCollectionInterface) => {
                        setReportContentList(data);
                    },
                    onError: (error: any) => {
                        setReportContentList(null);
                    },
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [prefixUploadFile, dispatch]);

    return (
        <GeneralDialog
            title={'prefixes:report.import_view'}
            dialogType={'info'}
            open={!!prefixUploadFile}
            disagreeCallback={closeReportViewCallback}
            maxWidth={'lg'}
            fullWidth
        >
            {reportContent && (
                <>
                    <GridContainer>
                        <GridItem xs={3}>
                            <I18n trans={`prefixes:report.${REPORT_PREFIX_ADDED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent[REPORT_PREFIX_ADDED]}</GridItem>
                        <GridItem xs={3}>
                            <I18n trans={`prefixes:report.${REPORT_PREFIX_MODIFIED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent[REPORT_PREFIX_MODIFIED]}</GridItem>
                        <GridItem xs={3}>
                            <I18n trans={`prefixes:report.${REPORT_PREFIX_SKIPPED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent[REPORT_PREFIX_SKIPPED]}</GridItem>
                        <GridItem xs={3}>
                            <I18n trans={`prefixes:report.${REPORT_PREFIX_REMOVED}`} />
                        </GridItem>
                        <GridItem xs={9}>{reportContent[REPORT_PREFIX_REMOVED]}</GridItem>
                        {!reportContentList && <GridItem xs={12}>Ładowanie szczegółów raportu...</GridItem>}
                        {reportContentList &&
                            reportContentList['hydra:member'].map((el: { lineNumber: number; reportContent: string }) => {
                                return (
                                    <>
                                        <GridItem xs={3}>
                                            <I18n trans={`prefixes:report.report_prefix_error`} /> {el.lineNumber}
                                        </GridItem>
                                        <GridItem xs={9}>{<I18n trans={el.reportContent} />}</GridItem>
                                    </>
                                );
                            })}
                        {reportContentList && reportContentList['hydra:view'] && (
                            <Pager callback={paginationCallbackFunction} views={reportContentList['hydra:view']} />
                        )}
                    </GridContainer>
                </>
            )}
        </GeneralDialog>
    );
};

export default PrefixUploadReportView;
